import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { AfterViewInit, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AlgoliaAccApplicationObject, AlgoliaAccVentureObject, AlgoliaObjectType, AlgoliaPersonObject, AlgoliaSearchObject, AutocompleteItem } from '@interfaces';
import { liteClient } from 'algoliasearch/lite';
import { environment } from '../../../environments';

@Component({
	selector: 'algolia-search',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './algolia-search.part.html'
})
export class AlgoliaSearchPart implements AfterViewInit {

	private readonly searchClient = liteClient(
		environment.algoliaConfig!.applicationId,
		environment.algoliaConfig!.apiKey
	);

	public searchHits = output<AlgoliaSearchObject[]>();
	public searchOnlyForPerson = input<boolean>(false);
	public objectTypes = input<AlgoliaObjectType[] | undefined>(undefined); // If provided, searches only the specified AlgoliaObjectType values

	constructor() { }

	private buildFacetFilters(): string[] | string[][] {
		const objectTypes = this.objectTypes();

		if (objectTypes?.length) {
			// Group object types as OR filters: (objectType:A OR objectType:B)
			return [objectTypes.map(type => `objectType:${type}`)];
		}

		if (this.searchOnlyForPerson()) {
			return ['objectType:Person'];
		}

		return [];
	}

	ngAfterViewInit() {
		// Initialize the autocomplete widget
		autocomplete<AutocompleteItem>({
			container: '#autocomplete',
			placeholder: 'Search for something...',
			detachedMediaQuery: 'none', // Disable detached mode(as we are using it in a dialog)
			shouldPanelOpen: () => false, // Disable the dropdown panel
			renderer: undefined,
			getSources: ({ query }) => [
				{
					sourceId: 'list',
					getItems: () => {
						return getAlgoliaResults({
							searchClient: this.searchClient,
							queries: [
								{
									indexName: environment.algoliaConfig!.indexName,
									params: {
										query,
										hitsPerPage: 100,
										facetFilters: this.buildFacetFilters(),
									},
								}
							],
							transformResponse: ({ hits }) => {
								const objects: AlgoliaSearchObject[] = [];
								hits.flat().forEach((hit: AutocompleteItem) => {
									objects.push({
										id: Number(hit.objectID.split(': ')[1]!), // Extract the id from the string
										objectID: hit.objectID,
										objectType: hit.objectType,
										displayName: hit.displayName,
										addressObj: ['Person'].includes(hit.objectType) ? (hit as AlgoliaPersonObject).addressObj : undefined,
										trimesterName: ['AccApplication', 'AccVenture'].includes(hit.objectType) ? (hit as AlgoliaAccApplicationObject | AlgoliaAccVentureObject).trimesterName : undefined,
										updatedUTC: hit.updatedUTC / 1000,
									} as AlgoliaSearchObject);
								});
								this.searchHits.emit(objects);
								return hits;
							},
						});
					},
					templates: { //templates is mandatory
						item({ item, components, html }) {
							return ''
						}
					},
				},
			],
			onStateChange: ({ state }) => {
				// Clear the selected item if the input is cleared
				if (!state.query) {
					this.searchHits.emit([]); // Emit empty array to indicate no selection
				}
			},

		});

	}
}